import React from 'react';
import { observer } from 'mobx-react-lite';
import globalUserProfile from '../../../../stores/global-user-profile';
import { ProfessorProfile } from '../../../../api/types/settings/settings-all';
import { UserType } from '../../../../api/types/user/user-type';
import { BranchLecturerRatesGroupDB } from '../../../../api/types/lecturers/user-details-lecturer';
import { UserPageLecturerRateItem } from '../../../../pages/user-page/roles/lecturer-price-rate/componenets/user-page-lecturer-rate-item';

export const MyRates = observer(() => {
  // Get the professor's rates from the global user profile
  const getRates = (): BranchLecturerRatesGroupDB[] => {
    if (!globalUserProfile.userProfile) return [];

    if (globalUserProfile.userProfile.userType === UserType.LECTURER) {
      const professorProfile = globalUserProfile.userProfile
        .profile as ProfessorProfile;
      return professorProfile.rates3 || [];
    }

    return [];
  };

  const rates = getRates();

  // Get the current user summary for props that need it
  const getCurrentUser = () => {
    return globalUserProfile.userProfile?.userWithRole;
  };

  const currentUser = getCurrentUser();

  const refreshLecturerDetails = async () => {
    if (!currentUser) return;

    try {
      // Refresh the entire user profile to get updated rates
      await globalUserProfile.getUserProfile();
    } catch (error) {
      console.error('Failed to refresh lecturer details:', error);
    }
  };

  if (!currentUser) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div>טוען נתונים...</div>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: '20px',
        width: '100%',
        minHeight: '100vh',
        backgroundColor: '#F9FAFB',
      }}
    >
      <div
        style={{
          color: '#041E49',
          fontSize: '30px',
          fontWeight: 'bold',
          marginBottom: '20px',
        }}
      >
        התעריפים שלי
      </div>

      <div
        style={{
          maxWidth: '100%',
          margin: '0 auto',
        }}
      >
        {rates.length === 0 ? (
          <div
            style={{
              textAlign: 'center',
              padding: '40px',
              color: '#6B7280',
              backgroundColor: 'white',
              borderRadius: '8px',
              border: '1px solid #E5E7EB',
            }}
          >
            לא נמצאו תעריפים
          </div>
        ) : (
          <div>
            {rates.map((activity, index) => (
              <UserPageLecturerRateItem
                key={`rate-${activity.settingsActivityTypeId}-${index}`}
                activity={activity}
                index={index}
                user={currentUser}
                onRefresh={refreshLecturerDetails}
                shouldDisplayFinancials={false}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
});
